import { isValidPhoneNumber } from "libphonenumber-js";

export const validateNumber = (phoneNumber, country) => {
  const number = String(phoneNumber);
  return isValidPhoneNumber(number, country);
};
